/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Tab_LinuxInputs */

const en_pc_dl_tab_linux = /** @type {(inputs: Pc_Dl_Tab_LinuxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux`)
};

const zh_pc_dl_tab_linux = /** @type {(inputs: Pc_Dl_Tab_LinuxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux`)
};

/**
* | output |
* | --- |
* | "Linux" |
*
* @param {Pc_Dl_Tab_LinuxInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_tab_linux = /** @type {((inputs?: Pc_Dl_Tab_LinuxInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Tab_LinuxInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_tab_linux(inputs)
	return zh_pc_dl_tab_linux(inputs)
});
export { pc_dl_tab_linux as "pc.dl.tab.linux" }